export const isManagedByTerraform = (managedBy?: string): boolean =>
  Boolean(managedBy?.includes('terraform'));
